import React, { ReactElement } from "react";

import { Layout } from "../../components";
import Mobile from "./mobile";
import Desktop from "./desktop";

function Home(): ReactElement {
  let width = window.innerWidth;
  let breakpoint = 768;

  return (
    <React.Fragment>
      <Layout>{width <= breakpoint ? <Mobile /> : <Desktop />}</Layout>
    </React.Fragment>
  );
}

export default Home;
